import { get } from '@/common/request'
import { getAsyncRoutes } from '@/common/tools'
import router from '@/router'
import cookieUtil from '@/common/cookie-util'
const app = {
  namespaced: true,
  state: {
    userInfo: null,
    menuList: [],
    loginStatus: '1',
    isRoutesLoaded: false,
  },
  getters: {
    userInfo: state => state.userInfo,
    menuList: state => state.menuList,
    loginStatus: state => state.loginStatus
  },
  mutations: {
    setRoutesLoaded(state, status) {
      state.isRoutesLoaded = status
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo || {}
    },
    setMenuList(state, menuList) {
      state.menuList = menuList || []
    },
    setLoginStatus(state, loginStatus) {
      state.loginStatus = loginStatus || '1'
    },
  },
  actions: {
    async getMenuList({ commit, state }) {
      // 如果已经加载过直接返回
      if (state.isRoutesLoaded) return;
      try {
        const menu = (await get('/permission/getMenu'))?.data?.menu;
        const menuList = getAsyncRoutes(menu);

        const notFoundRoute = {
          path: '*', // 通配符路径
          name: 'NotFound',
          component: () => import('@/views/exceptions/index.vue'), // 确保路径正确
          meta: {
            hideInMenu:true
          }
        };
        menuList.push(notFoundRoute);
        // 仅添加动态路由，移除静态路由添加
        router.addRoutes(menuList);

        // 合并菜单时使用展开运算符
        commit('setMenuList', [...menuList.filter(route => !route.hidden)]);
        commit('setRoutesLoaded', true);
        return menuList;
      } catch (e) {
        commit('setRoutesLoaded', false);
        if (e.status === 403) {
          cookieUtil.removeToken();
          router.push('/login');
        }
        return null;
      }
    },
  }
}

export default app
